import { gql } from 'graphql-request'

export namespace NotificationsSubscription {
  export namespace Notifications {
    export type Response = { notifications: Notification | null }
  }

  export function subscribeToNotifications() {
    return gql`
      subscription Notifications {
        notifications {
          id
          message
          notifiableId
          notifiableType
          notificationId
          userId
          parentTicketId
          parent {
            parentType
            parentId
          }
        }
      }
    `
  }
}

export interface Notification {
  id: number
  message: string
  notifiableId: number
  notifiableType: NotifiableType
  notificationId: number
  parent?: NotificationParent
  parentTicketId: number | null
  userId: number
}

export enum NotifiableType {
  Agent = 'Agent',
  Comment = 'Comment',
  PotentialBooking = 'PotentialBooking',
  Ticket = 'Ticket',
  TicketComment = 'TicketComment',
}

export interface NotificationParent {
  parentId: number
  parentType: NotificationParentType
}

export enum NotificationParentType {
  Corporate = 'Corporate',
  Lead = 'Lead',
  Member = 'Member',
  Ticket = 'Ticket',
}
